import styled from 'styled-components';
import { config } from '../../configuration';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';

import ProgressBar from './ProgressBar';
import { ConfirmationModal } from '~ui-kit';

import checkmarkSVG from '~images/checkmark.svg';
import attachmentSVG from '~images/attachment.svg';
import attachmentErrorSVG from '~images/attachment-error.svg';
import headerIcon from '~images/bigbin.svg';

const File = ({ upload, p, handleRemove, isTasklist, tasklistName, error }) => {
  if (isTasklist) {
    return (
      <Container tasklist>
        <FileIcon src={attachmentSVG} />
        <Details>
          <Name>
            <FileName>{tasklistName}</FileName>
          </Name>
        </Details>
      </Container>
    );
  }

  const name = upload.file ? upload.file.name : upload.originalFilename;
  const attachmentUrl =
    upload.originalFilename &&
    `${config.apiUrl}attachments/${upload.id}/media/${upload.originalFilename}`;

  return (
    <Container>
      {error && (
        <ErrorIndicator>
          <ErrorIcon icon={faExclamationTriangle} />
          Liitteen lataaminen epäonnistui
        </ErrorIndicator>
      )}
      <FileContainer error={error}>
        <FileIcon src={error ? attachmentErrorSVG : attachmentSVG} />
        <Details>
          <Name>
            <FileName>
              {attachmentUrl ? (
                <a
                  href={attachmentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {name}
                </a>
              ) : (
                <span>{name}</span>
              )}
            </FileName>
            {upload.file && <Check src={checkmarkSVG} visible={upload.id} />}
          </Name>
          {upload.file && !error && <ProgressBar p={p} />}
        </Details>
        <ConfirmationModal
          title="Olet poistamassa tiedostoa"
          content={<div>Haluatko varmasti poistaa tiedoston {name}?</div>}
          submit={() => handleRemove(upload)}
          headerIcon={headerIcon}
        >
          <Remove icon={faTrash} />
        </ConfirmationModal>
      </FileContainer>
    </Container>
  );
};

const Container = styled.div``;

const FileContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${props => (props.tasklist ? 'inherit' : 'grey')};
  // width: 300px;
  background-color: ${props => (props.error ? 'rgba(255,0,0,0.1)' : 'none')};
  border-left: 6px solid
    ${props => (props.error ? 'var(--errorColor)' : 'none')};
  border-radius: 4px;
  padding: 4px;

  margin-bottom: 16px;
`;

const ErrorIndicator = styled.div`
  margin-bottom: 4px;
`;

const ErrorIcon = styled(FontAwesomeIcon)`
  color: var(--errorColor);
  margin-right: 4px;
`;

const FileIcon = styled.img`
  height: 32px;
  margin-right: 16px;
`;

const Check = styled.img`
  height: 11px;
  opacity: ${props => (props.visible ? '100' : '0')};
  // transition: all 1s ease-in-out;
`;

const Details = styled.div`
  flex: 1 1 auto;
`;

const Name = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  // max-width: 200px;
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
`;

const FileName = styled.div`
  // max-width: 160px;
  word-wrap: break-word;
  word-break: break-all;
  flex-shrink: 1;
  margin-right: 8px;
`;

const Remove = styled(FontAwesomeIcon)`
  cursor: pointer;
  margin-left: 16px;

  &:hover {
    transform: scale(1.15);
    transition: transform 0.1s;
  }
`;

export default File;
